import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Subnav/sgds-subnav";
import { register } from "../../utils/ce-registry";

register("sgds-subnav", Component);

export default createComponent({
  react: React,
  tagName: "sgds-subnav",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
